import {useCallback, useState} from 'react';
import {
  CategoryType,
  SubCategoryType,
  titleToId,
} from '~/common/components/MegaNav/MegaNavVariant/types';
import {Button} from '~library/atoms/Button';
import {Link} from '~library/atoms/Link';
import {Typography} from '~library/atoms/Typography';
import {useTracking} from '~library/context/tracking/tracking-context';

import * as styles from './SubCategory.module.scss';

const MAX_SUB_CATEGORY = 9;

export const SubCategory = ({subCategory}: {subCategory: SubCategoryType}) => {
  const [showingAll, setShowingAll] = useState(false);
  const {track} = useTracking();

  const onViewMoreClick = useCallback(() => setShowingAll(true), []);

  const {categories} = subCategory;

  const categoriesToDisplay = showingAll ? categories : categories?.slice(0, MAX_SUB_CATEGORY);

  const handleCategoryClick = useCallback(
    (category: CategoryType) => () => {
      track({
        dataQaId: category.dataQaId,
        href: category.href,
        displayName: category.display_name,
        subCategoryName: subCategory.display_name,
        subCategoryId: titleToId(category.display_name),
      });
    },
    [track, subCategory]
  );

  return (
    <div className={styles.subCategory}>
      <Typography
        variant="paragraph4"
        classNames={styles.subCategoryHeader}
        data-qa-id={subCategory.dataQaId}
        color="coin"
        semibold
      >
        {subCategory.display_name}
      </Typography>
      <div className={styles.subCategoryLinks}>
        {categoriesToDisplay?.map((category: CategoryType) => (
          <Link
            key={category.display_name}
            href={category.href}
            data-qa-id={category.dataQaId}
            className={styles.subCategoryLink}
            onClick={handleCategoryClick(category)}
          >
            {category.display_name}
          </Link>
        ))}
        {!showingAll && (categoriesToDisplay?.length ?? 0) < (categories?.length ?? 0) && (
          <Button
            onClick={onViewMoreClick}
            data-qa-id="view-more"
            className={styles.viewMoreButton}
            variant="link"
          >
            View more
          </Button>
        )}
      </div>
    </div>
  );
};
